import { Box, Modal, Typography } from "@mui/material";
import { useMutation } from "@tanstack/react-query";
import useAPI from "../../../../../api/hooks/useAPI";
import useColors from "../../../../../api/hooks/useColors";
import ContainedButton from "../../../../../components/buttons/ContainedButton";
import TextButton from "../../../../../components/buttons/TextButton";
import { Toast } from "../../../../../components/Toast";
import SvgToIcon from "../../../../../icons/SvgToIcon";
import { ReactComponent as SuccessSVG } from "../../../../stack/environment/icons/severity_icons/severity-icons-success-24.svg";

export default function SuccessfulAddedChannelModal({
  isOpen,
  setIsOpen,
  channelID,
  setChannelID,
}) {
  const colors = useColors();
  const { trackEvent, sendSlackChannelTestMessage } = useAPI();

  const testChannelMutation = useMutation({
    mutationFn: () => sendSlackChannelTestMessage(channelID),
    onSuccess: () => {
      Toast.success("Test message sent successfully");
      handleClose();
    },
    onError: () => {
      Toast.error("Failed sending test message");
      handleClose();
    },
  });

  const handleClose = () => {
    setIsOpen(false);
    setChannelID("");
  };

  const handleSendTestMessage = () => {
    trackEvent("User sent a test message to Slack channel");
    testChannelMutation.mutate(channelID);
  };

  return (
    <Modal open={isOpen} onClose={handleClose}>
      <Box
        padding="24px"
        position="absolute"
        borderRadius="10px"
        top="50%"
        left="50%"
        sx={{
          transform: "translate(-50%, -50%)",
          backgroundColor: colors.modal_bg,
          outline: "none",
        }}
      >
        <Box display="flex" flexDirection="column" gap={3}>
          <Box display="flex" gap={1}>
            <SvgToIcon IconLogo={SuccessSVG} />
            <Typography variant="subtitle1">
              Channel added successfully
            </Typography>
          </Box>
          <Typography variant="body2">
            Want to make sure it’s working?
            <br />
            Send yourself a test message to confirm everything is set up
            properly.
          </Typography>
          <Box display="flex" gap={2} justifyContent="center">
            <ContainedButton
              onClick={handleSendTestMessage}
              color="success"
              size="medium"
              loading={testChannelMutation.isPending}
            >
              Send test message
            </ContainedButton>
            <TextButton
              onClick={handleClose}
              color="inherit"
              disabled={testChannelMutation.isPending}
            >
              Cancel
            </TextButton>
          </Box>
        </Box>
      </Box>
    </Modal>
  );
}
